import React, { useState } from "react";
import { classNames } from "../../../helpers/classNames";

const Search = ({ placeholder, divClasses, inputClasses, iconClasses, iconPosition = "left", searchValue, icon = "fa-regular fa-magnifying-glass", search = () => { }, onKeyDown = () => { }, }) => {
  const [isFocused, setFocused] = useState(false);
  return (
    <>
      <div className={classNames("relative flex items-center h-12 w-full bg-transparent rounded-md overflow-hidden border transition-all duration-300", isFocused ? "border-shades-01" : "border-shades-02", divClasses)}>
        {iconPosition === "left" && (
          <div className={classNames("h-12 aspect-square flex-shrink-0 text-base flex items-center justify-center transition-all duration-300", iconClasses, isFocused ? "text-shades-01" : "text-shades-02")}>
            <i className={classNames("fa-fw", icon)}></i>
          </div>
        )}
        <input
          type="text"
          placeholder={placeholder}
          className={classNames("font-light text-sm flex-shrink !border-0 w-full !ring-0 bg-transparent text-white placeholder:text-shades-01 placeholder:text-sm h-12 ", inputClasses, iconPosition === "left" ? "pr-4 pl-0" : iconPosition === "right" ? "pl-4 pr-0" : "")}
          value={searchValue}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => search(e.target.value)}
          onKeyDown={onKeyDown}
        />
        {iconPosition === "right" && (
          <div className={classNames("h-12 aspect-square flex-shrink-0 text-base flex items-center justify-center transition-all duration-300", iconClasses, isFocused ? "text-shades-01" : "text-shades-02")}>
            <i className={classNames("fa-fw", icon)}></i>
          </div>
        )}
      </div>
    </>
  );
};

export default Search;
